<template>
  <main class="container-fluid">
    <b-row>
      <b-col
        sm="12"
        class="text-right my-1"
      >
      <locale />
      </b-col>
    </b-row>
    <b-row
      class="d-flex justify-content-center pt-1"
    >
      <b-col
        sm='12'
        class="text-center pb-1"
      >
      <!-- Brand logo-->
      <b-link>
        <img class="img_logo" :src="logo" alt="logo">
      </b-link>
      <!-- /Brand logo-->
      </b-col>
    </b-row>
  
  <div class="auth-wrapper auth-v2 padd_auth">
    <div class="auth-inner mainrowtxt">
      <b-row>

        <!-- Left Text-->
        <b-col
          lg="7"
          md="6"
          class="d-none d-md-flex align-items-center"
        >
          <div class="w-100 d-md-flex align-items-center justify-content-center px-2">
            <b-img
              fluid
              :src="imgUrl"
              alt="Login"
            />
          </div>
        </b-col>
        <!-- /Left Text-->

        <!-- Login-->
        <b-col
          lg="5"
          md="6"
          sm="12"
          class="d-flex align-items-center auth-bg rounded-lg"
        >
          <b-col
            cols="12"
            class="px-md-2 px-sm-1 mx-auto"
          >
            <b-card-title
              class="mb-1 titlesft font-weight-bold"
              title-tag="h2"
            >
              <span class="welcome">{{$t('message.welcome_to')}}</span> <span class="sft_title_login">Safetravel.today!</span>
            </b-card-title>
            <b-card-text class="mb-2 signintxt">
              {{$t('message.adventure')}}
            </b-card-text>

            <b-alert
              variant="primary"
              show
            >
              <div class="alert-body font-small-2">
                <article>
                  <p class="lead">Demo</p>
                  <p class="mr-50 lead"><span>{{$t('message.username')}}:</span> demo@safetravel.today | <span>{{$t('message.password')}}:</span> 123456!@#</p>
                </article>
              </div>
              <feather-icon
                v-b-tooltip.hover.left="'Demo Account'"
                icon="HelpCircleIcon"
                size="18"
                class="position-absolute"
                style="top: 10; right: 10;"
              />
            </b-alert>
            
            <!-- credentials error -->
            <b-alert class="creds_error_alert" v-if="genericError" :key="errorKey" variant="danger" show dismissible fade>
              <p class="text-dark font-weight-bold">{{$t('message.creds_err')}}</p>
            </b-alert>

            <!-- form -->
            <validation-observer
              ref="loginForm"
              #default="{invalid}"
            >
              <b-form
                class="auth-login-form mt-2"
                @submit.prevent="login"
              >
                <!-- email -->
                <b-form-group
                  label="Email"
                  label-for="login-email"
                >
                  <validation-provider
                    ref="emailProvider"
                    #default="{ errors }"
                    name="Email"
                    vid="email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="login-email"
                      v-model="userEmail"
                      :state="errors.length > 0 ? false:null"
                      name="login-email"
                      placeholder="john@example.com"
                      autocomplete="username email"
                      required
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- forgot password -->
                <b-form-group>
                  <div class="d-flex justify-content-between">
                    <label for="login-password">{{$t('message.password')}}</label>
                    <b-link :to="{name:'auth-forgot-password'}">
                      <small>{{$t('message.forgot_pass')}}</small>
                    </b-link>
                  </div>
                  <validation-provider
                    ref="passwordProvider"
                    #default="{ errors }"
                    name="Password"
                    vid="password"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid':null"
                    >
                      <b-form-input
                        id="login-password"
                        v-model="password"
                        :state="errors.length === 0 ? null : false"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        name="login-password"
                        placeholder="Password"
                        autocomplete="current-password"
                        required
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- submit buttons -->
                <b-button
                  type="submit"
                  variant="primary"
                  block
                  :disabled="canSubmit"
                >
                  {{$t('message.sign_in')}}
                </b-button>
              </b-form>
            </validation-observer>
            <!-- request access -->
            <div class="request_access">
              <span>{{$t('message.notapartner')}}</span>
              <b-link :to="{ name: 'request-access' }">
                <strong> {{$t('message.requestAccess')}}</strong>
              </b-link>
            </div>
          </b-col>
        </b-col>
      <!-- /Login-->
      </b-row>
    </div>
  </div>
  </main>
</template>

<script>
/* eslint-disable global-require */
import Locale from '../components/Locale.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BAlert, VBTooltip,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    ValidationProvider,
    ValidationObserver,
    Locale
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      logo: require('@/assets/images/quotation/sft_logo.svg'),
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      genericError: false,
      errorKey: 0,
      loading: false,
      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
    canSubmit() {
      // disable button if loading
      return this.loading
    }
  },
  methods: {
    login() {
        if (this.loading) return; // prevent double-clicks
        this.loading = true
        this.genericError = false // reset before login attempt
        const crd = {
          "username":this.userEmail,
          "password":this.password
        }
        fetch('https://api-quote.safetravel.today/v2/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(crd)
        })
        .then((response)=> {
          if (!response.ok) throw new Error(`Login failed: HTTP ${response.status}`);
          return response.json();
        })
        .then((res)=> {
          if (res) {
            if (!res.jwt) {
              this.genericError = true
              this.errorKey = Date.now() // force fresh alert
            }
            else {
              useJwt.login({
                email: null,
                password: null,
                details: res.jwt
              })
                .then(response => {
                  const { userData } = response.data
                  useJwt.setToken(response.data.accessToken)
                  useJwt.setRefreshToken(response.data.refreshToken)
                  this.$ability.update(userData.ability)
                  // SAVE USER DATA TO VUEX
                  this.$store.commit('app/USER_DATA', userData)
                  // ? This is just for demo purpose as well.
                  // ? Because we are showing eCommerce app's cart items count in navbar
                  this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', userData.extras.eCommerceCartItemsCount)
                  // hide cred modal
                  this.genericError = false
                  this.$router.replace(getHomeRouteForLoggedInUser(userData.role))
                    .then(() => {
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: `Welcome ${userData.fullName || userData.username}`,
                          icon: 'CoffeeIcon',
                          variant: 'success',
                          text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
                        },
                      })
                    })
                    .catch(err => {
                      if (err.name !== 'NavigationDuplicated') {
                        console.error('Navigation error:', err);
                      }
                    });
                })
                .catch(error => {
                  console.error(error)
                  this.genericError = true
                  this.errorKey = Date.now() // force fresh alert
                })
            }
          } else {
            this.genericError = false
          }
        })
        .catch((err)=> {
          console.error(err);
          this.genericError = true
          this.errorKey = Date.now() // force fresh alert
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.creds_error_alert {
  padding: 1rem 0;
  text-align: center;
  color:#000;
  font-weight: 600;
}
.creds_error_alert .close {
  font-weight:900;
  color: var(--danger) !important;
}
.img_logo {
  display: inline-block;
  margin: 0 auto;
  max-width: 650px;
  width: 80%;
  height: auto;
}
.welcome {
  color: var(--foreground-color);
  font-weight: 500;
}
.sft_title_login {
  color: var(--accent3-color);
  font-weight: 600;
}
.signintxt {
  color: var(--foreground-color);
}
.request_access {
  margin-top: 22px;
  margin-bottom:12px;
  text-align: center;
}
.padd_auth {
  padding-top:30px;
}
.titlesft {
  margin-top:15px;
}
@media screen and (max-width: 992px) {
  .mainrowtxt {
    margin-top:25px;
  }
}
@media screen and (max-width: 756px) {
  .mainrowtxt {
    margin-top:25px;
  }
  .request_access {
    margin-bottom:18px;
  }
  .padd_auth {
    padding-top:0;
  }
  .titlesft {
    margin-top:25px;
  }
}
</style>
